<template>
  <div class="rounded-sm border p-4">
    <div class="flex items-center space-x-5">
      <div v-if="showProgressBar" class="relative grow-0">
        <circle-progress
          :size="44"
          :border-width="3"
          :border-bg-width="3"
          :percent="percentValue"
          :fill-color="fillColor"
          :show-max-value="showMaxValue"
          empty-color="#EBEEF5"
        />
        <span
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform"
        >
          <icon-base v-if="showIcon" :icon="icon" :iconColor="fillColor" />
        </span>
      </div>
      <div class="grow">
        <div class="text-sm text-gray-400">
          <slot></slot>
        </div>
        <div class="text-xl font-bold text-headline">
          {{ total }}{{ showMaxValue && value ? `/${max}` : "" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Component, type PropType, computed } from "vue";
import CircleProgress from "vue3-circle-progress";

import { moneyToTwoDecimal } from "@/helpers/formatting";

const props = defineProps({
  value: {
    type: [String, Number],
    required: true,
  },
  max: {
    type: Number,
    default: 100,
  },
  icon: {
    type: [String, Object] as PropType<string | Component>,
    default: "",
  },
  fillColor: {
    type: String,
    default: "#3769D6",
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  showProgressBar: {
    type: Boolean,
    default: true,
  },
  showMaxValue: {
    type: Boolean,
    default: false,
  },
  isPercentage: {
    type: Boolean,
    default: false,
  },
  isPrice: {
    type: Boolean,
    default: false,
  },
  fillCircle: {
    type: Boolean,
    default: true,
  },
});

const percentValue = computed(() =>
  props.fillCircle ? (+props.value / +props.max) * 100 : 0
);

const total = computed(() => {
  if (!props.value) {
    return "-";
  }
  if (props.isPrice) {
    return `${moneyToTwoDecimal(props.value)}`;
  }
  if (props.isPercentage) {
    return `${props.value}%`;
  }
  return props.value;
});
</script>
